import clsx from "clsx";
import { useAtom } from "jotai";

import { SNHU_EXTRA_ENTRIES } from "../../constants/snhu.constants";
import { pagesAtom, progressAtom } from "../../snhu.state";
import { Pages } from "../../snhu.types";

interface LayoutProps {
  children: React.ReactNode;
}

export function Layout({ children }: LayoutProps): JSX.Element {
  const [progress] = useAtom(progressAtom);
  const [page] = useAtom(pagesAtom);

  return (
    <div className="snhu__container">
      <div className={clsx(
        "lander__cpl__quiz__header",
        "snhu__header",
        page === Pages.CONFIRMATION && "confetti"
      )}>
        <span className={clsx("lander__cpl__quiz__header--description", "snhu__description")}>
          {page === Pages.CONFIRMATION
            ? "Congratulations!"
            : `Complete the survey to secure +${SNHU_EXTRA_ENTRIES} extra entries`
          }
        </span>

        <div key={progress} className="lander__quiz__header--progress-bar--container">
          <div className="progress-bar-container">
            <div
              className="progress-bar-indicator"
              style={{ width: `${progress}%` }}
            />
          </div>
        </div>
      </div>

      {children}

      <img
        src="https://cdn.shopify.com/s/files/1/0265/0062/8528/files/snhu_logo.png?v=1741613925"
        alt="SNHU Logo"
        className="snhu__logo"
      />
    </div>
  );
}
